export const clients = [
  {
    name: 'Agencia Pólux',
    route: 'https://agenciapolux.nestconsultores.cl/',
  },
  {
    name: 'Megaphone',
    route: 'https://megaphone.nestconsultores.cl/',
  },
  {
    name: 'Cerberus Legal',
    route: 'https://gestor-de-proyectos.cerberus-legal.com/iniciar-sesion',
    system: 'CERBERUS',
  },
  {
    name: 'Universidad del Bío - Bío',
    route: 'http://ubb.nestconsultores.cl/',
    system: 'UBB',
  },
  {
    name: 'ANID',
    route: 'https://anid.nestconsultores.cl/',
    system: 'ANID',
  },
  {
    name: 'SENCE',
    route: 'https://sence.nestconsultores.cl/',
    system: 'SENCE',
  },
  {
    name: 'Soporte Tickets - MOP',
    route: 'https://ticketmop.nestconsultores.cl/',
  },
  {
    name: 'PolarisBI - HOME',
    route: 'https://polarisbi.nestconsultores.cl/',
  },
    {
    name: 'PolarisBI - DEMO',
    route: 'https://polarisbi-demo.nestconsultores.cl/',
  },
]
